export default "__VITE_ASSET__C4Ggx35___"